import { DataRoomFormData } from './formData';

export enum DataRoomTab {
  General = 'general',
  SiteTerms = 'site-terms',
  Content = 'content',
  Documents = 'documents',
  Access = 'access',
}

export const dataRoomTabFields: Record<
  DataRoomTab,
  Array<keyof DataRoomFormData>
> = {
  [DataRoomTab.General]: [
    'status',
    'headline',
    'subheading',
    'contact',
    'keyInformation',
  ],
  [DataRoomTab.SiteTerms]: [],
  [DataRoomTab.Content]: [],
  [DataRoomTab.Documents]: [],
  [DataRoomTab.Access]: [],
};

export const dataRoomTabs: Array<{ label: string; id: DataRoomTab }> = [
  {
    label: 'General',
    id: DataRoomTab.General,
  },
  {
    label: 'Site terms',
    id: DataRoomTab.SiteTerms,
  },
  {
    label: 'Content',
    id: DataRoomTab.Content,
  },
  {
    label: 'Documents',
    id: DataRoomTab.Documents,
  },
  {
    label: 'Access',
    id: DataRoomTab.Access,
  },
];
